// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import  'babel-polyfill'
import Vue from 'vue'
// import VueResource  from 'vue-resource'
import App from './App'
import ElementUI from 'element-ui'
import _ from 'lodash'
import $ from 'jquery'
import 'element-ui/lib/theme-default/index.css'
import router from './router'
import  './permission'
import  './compnent/input';
import store from './store'
import  MyPlugin  from './commonJs/Vue_install'
import * as filters from './commonJs/filters' // 全局filter

// 配置是否允许 vue-devtools 检查代码。开发版本默认为 true，生产版本默认为 false。生产版本设为 true 可以启用检查。
Vue.config.productionTip = false
// 开启debug模式
Vue.config.debug = true;
//取消所有日志与警告
Vue.config.silent = true;

Vue.use(ElementUI)
Vue.use(MyPlugin);


Vue.config.errorHandler = function (err, vm, info) {
  // handle error
  // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
  // 只在 2.2.0+ 可用
  console.log("errorHandler",err,vm,info);
}

//自定义过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // watch: {
  // 监视路由，参数为要目标路由和当前页面的路由
  //'$route' (to, from){
  //const toDepth = to.path.substring(0, to.path.length-2).split('/').length
  // 官方给出的例子为 const toDepth = to.path.split('/').length 由于现在只有两个路由路径'/'和'/detail'
  // 按照官方给的例子，这两个路由路径深度都为 2 ，所以，这里稍作调整，不知道有什么不妥
  // 但目前在这个demo中能正常运行，如果知道更好的方法，欢迎留言赐教
  //const fromDepth = from.path.substring(0, from.path.length-2).split('/').length
  //this.transitionName = toDepth < fromDepth ? 'slide_back' : 'slide'
  // 根据路由深度，来判断是该从右侧进入还是该从左侧进入
  //}
  //},
  template: '<App/>',
  // watch: {
  //   '$route' (to, from) {
  //     // 对路由变化作出响应...
  //     console.log(this);
  //   }
  // },
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js